

export default {

    name: 'filledForm',
    props: {
        formId: {
            type: Number,
            required: false,
            default: 0
        },
    },
    created() {

        let t = this;

        t.list.country = window['COUNTRY_LIST'];

        t.list.country.forEach(item => {
            item.icon = 'assets/img/flag/' + item.code + '.svg';
        });

        t.dict.country = listToDict(t.list.country, 'code');

        t.list.gender = [
            { id: 1, text: t.t('男') },
            { id: 2, text: t.t('女') },
            { id: 3, text: t.t('LGBTQ') },
        ];

        t.dict.gender = listToDict(t.list.gender);

        t.list.lang = [
            { id: 1, text: '日本人' },
            { id: 2, text: '「在留カード」を持ち外国人' },
            { id: 3, text: 'English' },
            { id: 4, text: '中文' },
            { id: 5, text: '한국어' },
        ];

        t.dict.lang = listToDict(t.list.lang);

        t.list.status = [
            { id: 1, text: t.t('Unconfirmed') },
            { id: 2, text: t.t('Confirmed') },
        ];

        t.dict.status = listToDict(t.list.status);

        t.loadData();

    },
    activated() {

        let t = this;

    },
    methods: {

        sendPasswordEmail(form) {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.post('form/sendPasswordEmail/' + form.id).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    form.email_status = 3;
                    A.toast('送信完了');
                }
                else {
                    A.err('メール送信に失敗しました');
                }
            });

        },

        loadData() {
            let t = this;

            axios.get('group').then(res => {
                if (res.data.status == 1) {

                    let arr = res.data.options.items;

                    t.dict.group = listToDict(arr);

                    t.list.group = arr;

                    axios.get('room').then(res => {

                        if (res.data.status == 1) {

                            let dictRoom = {};

                            t.list.room = res.data.options.items;

                            dictRoom = listToDict(t.list.room);

                            arr.forEach(group => {
                                group.rooms = [];
                                let roomIds = group.room_ids.split(',');
                                roomIds.forEach(roomId => {
                                    if (dictRoom[roomId]) {
                                        dictRoom[roomId].group = group;
                                        group.rooms.push(dictRoom[roomId]);
                                    }

                                });
                            });

                            t.dict.room = dictRoom;

                            t.loadForm();

                        }

                    });


                }
            });

        },

        loadForm() {

            let t = this;


            axios.get('form/' + t.formId).then(res => {
                // axios.get('form/' + 19468).then(res => {
                t.form = res.data.options.item;
                if (t.form) {

                    t.form.people_items = [];

                    if (t.form.people_data)
                        t.form.people_items = JSON.parse(t.form.people_data);

                    t.v.room = t.dict.room[t.form.room_id];
                    t.v.group = t.v.room.group;

                    t.passportUploader.items2 = [];

                    if (t.form.rc_urls) {
                        let urls = t.form.rc_urls.split(',');

                        t.passportUploader.items2 = [];
                        urls.forEach(url => {
                            t.passportUploader.items2.push(({ success: true, img_url: url, validation: false }));
                        });
                    }

                    t.passportUploader.items = [];

                    if (t.form.passport_urls) {
                        let urls = t.form.passport_urls.split(',');
                        let passportData = JSON.parse(t.form.passport_data);

                        t.passportUploader.items = [];

                        let i = 0;
                        urls.forEach(url => {
                            let data = passportData[i];
                            t.passportUploader.items.push(({ success: true, data: data, img_url: url, validation: true }));
                            i++;
                        });
                    }

                    if (t.v.room.static_password && t.v.room.static_password != 'AUTO') {
                        t.form.realPassword = t.v.room.static_password;
                    }
                    else {
                        if (t.form.door_password == 'ADMIN_PWD') {
                            t.form.realPassword = t.v.room.admin_password;
                        }
                        else {
                            t.form.realPassword = t.form.door_password.indexOf('#') > -1 ? t.form.door_password : (t.form.door_password + '#');
                        }
                    }
                }
            });

        },

        deleteForm() {

            let t = this;
            Swal.mixin({
                customClass: {
                    confirmButton: 'btn-lg btn-orange',
                    cancelButton: 'btn-sm btn-dark mr10'
                },
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
                buttonsStyling: false,
                showCancelButton: true
            }).fire('データーを削除', "よろしいですか。", 'warning').then(res => {
                if (res.isConfirmed) {
                    axios.post('form/delete', { id: t.form.id }).then(res => {
                        t.loadData();
                    });
                }
            });

        },

    },
    data() {
        return {
            form: null,
            v: {
                date: '',
                room: null,
                group: null,
            },
            list: {
                group: [],
                country: [],
                gender: [],
                lang: [],
                status: []
            },

            dict: {
                group: {},
                room: {},
                country: {},
                gender: {},
                lang: {},
                status: {},
            },

            passportUploader: {
                current: null,
                items: [
                ],
                items2: []
            },
        };
    },
};
